import Routes from "./routes";

export default () => {
  return <Routes />;
};
